import {
  getAuth,
  confirmPasswordReset,
  verifyPasswordResetCode,
} from "firebase/auth";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { sleep } from "../helpers/general";
import { message } from "antd";
import React from "react";
import Button from "../components/Button";

const passwordLowerThreshold = 6;
const passwordUpperThreshold = 15;

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmedPassword, setConfirmedPassword] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [validPassword, setValidPassword] = useState(false);
  const [revealPassword, setRevealPassword] = useState(false);
  const [reavealConfirmedPassword, setReavealConfirmedPassword] =
    useState(false);

  let password1Ref = React.createRef();
  let password2Ref = React.createRef();

  useEffect(() => {
    setValidPassword(
      password === confirmedPassword &&
        password.length >= passwordLowerThreshold &&
        password.length <= passwordUpperThreshold
    );
  }, [password, confirmedPassword]);

  async function handleResetPassword() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const mode = urlParams.get("mode");
      const actionCode = urlParams.get("oobCode");
      const auth = getAuth();

      if (mode === "resetPassword") {
        await verifyPasswordResetCode(auth, actionCode);
        await confirmPasswordReset(auth, actionCode, password);
        message.success("Password updated successfully");
        await sleep(2);
        window.location = "/";
      }
    } catch (error) {
      console.error(error);
      setIsSaving(false);
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    handleResetPassword();
  };

  return (
    <Container>
      <Header>Reset Password</Header>
      <form onSubmit={onSubmit}>
        <InputHeader>New password</InputHeader>
        <InputContainer>
          <InputField
            className="transition-colors"
            placeholder={`Must be between ${passwordLowerThreshold} and ${passwordUpperThreshold} characters`}
            value={password}
            maxLength={40}
            onChange={(e) => setPassword(e.target.value)}
            type={revealPassword ? "text" : "password"}
            ref={password1Ref}
          />
          <span
            className="flex justify-around items-center"
            onClick={() => {
              setRevealPassword(!revealPassword);
              password1Ref.current.focus();
            }}
          >
            {revealPassword ? (
              <HidePasswordIcon src="/images/general/password-hide.svg" />
            ) : (
              <RevealPasswordIcon src="/images/general/password-reveal.svg" />
            )}
          </span>
        </InputContainer>
        <InputHeader>Confirm new password</InputHeader>
        <InputContainer>
          <InputField
            className="transition-colors"
            placeholder="Type your new password again"
            value={confirmedPassword}
            maxLength={40}
            onChange={(e) => setConfirmedPassword(e.target.value)}
            type={reavealConfirmedPassword ? "text" : "password"}
            ref={password2Ref}
          />
          <span
            className="flex justify-around items-center"
            onClick={() => {
              setReavealConfirmedPassword(!reavealConfirmedPassword);
              password2Ref.current.focus();
            }}
          >
            {reavealConfirmedPassword ? (
              <HidePasswordIcon src="/images/general/password-hide.svg" />
            ) : (
              <RevealPasswordIcon src="/images/general/password-reveal.svg" />
            )}
          </span>
        </InputContainer>
        <ButtonContainer>
          <Button
            type="submit"
            variant="primary"
            size="medium"
            disabled={!validPassword}
            isLoading={isSaving}
            width="100%"
          >
            Save
          </Button>
        </ButtonContainer>
      </form>
    </Container>
  );
}

const Container = styled.div`
  text-align: left;
  margin: auto;
  margin-top: 30px;
  width: 90%;
  max-width: 650px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 24px;
`;

const Header = styled.div`
  letter-spacing: 0em;
  font-size: 32px;
  font-weight: 700;
  line-height: 51px;
  text-align: left;
`;

const InputHeader = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-align: left;
  color: var(--color-gray-50);
  margin-bottom: 12px;
  margin-top: 24px;
`;

const InputField = styled.input`
  font-size: 14px;
  width: 100%;
  height: 50px;
  border: 1px solid;
  border-color: black;
  padding-left: 18px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  width: 100%;
  margin: auto;
  border-radius: 8px;

  &:focus {
    border-color: #978ad7;
  }

  &:focus-visible {
    outline: 0;
  }

  &::placeholder {
    font-style: italic;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
  }
`;

const InputContainer = styled.div`
  position: relative;
`;

const RevealPasswordIcon = styled.img`
  right: 14px !important;
  top: 29%;
  height: 20px;
  width: 20px;
  position: absolute;
`;

const HidePasswordIcon = styled.img`
  right: 14px !important;
  top: 29%;
  height: 20px;
  width: 20px;
  position: absolute;
`;
